export const baseColors = {
  white: 'white',
  failure: '#EC5F4C',
  failure33: '#EC5F4C33',
  primary: '#FFC9B1',
  primary0f: '#1FC7D40f',
  primary3D: '#1FC7D43D',
  primaryBright: '#53DEE9',
  primaryDark: '#0098A1',
  success: 'rgba(25, 154, 84, 1)',
  success19: '#FFC9B119',
  warning: '#FFB237',
  warning2D: '#ED4B9E2D',
  warning33: '#ED4B9E33',
  borderColor: 'rgba(144, 83, 64,1)',
  headerColor: 'rgba(255, 255, 255, 0.45)',
  cardBgColor: 'rgba(47, 40, 40, 0.5)',
}

export const additionalColors = {
  binance: '#F0B90B',
  overlay: '#452a7a',
  gold: '#FFC700',
  silver: '#B2B2B2',
  bronze: '#E7974D',
}

export const lightColors = {
  ...baseColors,
  ...additionalColors,
  secondary: '#FC5A44',
  secondary80: '#FC5A4480',
  background: '#FAF9FA',
  backgroundDisabled: '#E9EAEB',
  backgroundAlt: '#FFFFFF',
  backgroundAlt2: 'rgba(255, 255, 255, 0.7)',
  cardBorder: 'rgba(47, 40, 40, 0.9)',
  contrast: '#191326',
  dropdown: '#F6F6F6',
  dropdownDeep: '#EEEEEE',
  invertedContrast: '#FFFFFF',
  input: '#eeeaf4',
  inputSecondary: '#d7caec',
  tertiary: '#EFF4F5',
  text: '#FFFFFF',
  text99: '#280D5F99',
  textDisabled: '#BDC2C4',
  textSubtle: '#7A6EAA',
  disabled: '#E9EAEB',
  gradientBubblegum: 'linear-gradient(139.73deg, #302423 0%, #302423 100%)',
  gradientInverseBubblegum: 'linear-gradient(139.73deg, #F3EFFF 0%, #E5FDFF 100%)',
  gradientCardHeader: 'linear-gradient(111.68deg, #F2ECF2 0%, #E8F2F6 100%)',
  gradientBlue: 'linear-gradient(180deg, #A7E8F1 0%, #94E1F2 100%)',
  gradientViolet: 'linear-gradient(180deg, #E2C9FB 0%, #CDB8FA 100%)',
  gradientVioletAlt: 'linear-gradient(180deg, #CBD7EF 0%, #9A9FD0 100%)',
  gradientGold: 'linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)',
  gradientBold: 'linear-gradient(#FFC9B1, #FFC9B1)',
}

export const darkColors = {
  ...baseColors,
  ...additionalColors,
  secondary: '#FFC9B1',
  secondary80: '##FC5A4480',
  background: 'rgba(255, 255, 255, 0.08)',
  backgroundDisabled: '#3c3742',
  backgroundAlt: '#292929',
  backgroundAlt2: 'rgba(39, 38, 44, 0.7)',
  cardBorder: 'rgba(47, 40, 40, 0.9)',

  contrast: '#FFFFFF',
  dropdown: '#1E1D20',
  dropdownDeep: '#100C18',
  invertedContrast: '#191326',
  // input: 'rgba(255, 255, 255, 0.08)',
  input: '#000000',
  inputSecondary: '#262130',
  primaryDark: '#0098A1',
  tertiary: 'rgba(255, 255, 255, 0.08)',
  text: '#FFFFFF',
  text99: '#F4EEFF99',
  textDisabled: 'rgba(255, 255, 255, 0.25)',
  textSubtle: 'rgba(255, 255, 255, 0.65)',
  disabled: '#524B63',
  gradientBubblegum: 'linear-gradient(139.73deg, #302423 0%, #302423 100%)',
  gradientInverseBubblegum: 'linear-gradient(139.73deg, #3D2A54 0%, #313D5C 100%)',
  gradientCardHeader: '#292929',
  gradientBlue: 'linear-gradient(180deg, #00707F 0%, #19778C 100%)',
  gradientViolet: 'linear-gradient(180deg, #6C4999 0%, #6D4DB2 100%)',
  gradientVioletAlt: 'linear-gradient(180deg, #434575 0%, #66578D 100%)',
  gradientGold: 'linear-gradient(180deg, #FFD800 0%, #FDAB32 100%)',
  gradientBold: 'linear-gradient(#FFC9B1, #FFC9B1)',
}
